import axios from 'axios';

export default function() {
  return {
    namespaced: true,
    state: {
      announcement: { 
        // {locale : { data, __updatedAt }}
      },
    },
    mutations: {
      UPDATE_ANNOUNCEMENTS(state, { data, locale }) {
        state.announcement = {
          ...state.announcement,
          [locale]: {
            ...data,
            __updatedAt: Date.now(),
          }
        }
      },
    },
    actions: {
      FETCH({ state, commit }, { locale }) {
        return axios.get(encodeURI(`/api/announcement`))
          .then((res) => {
            const data = res.data || [];
            commit('UPDATE_ANNOUNCEMENTS', { data, locale});
          }).catch(err => console.log(err));      
      },
    },
    getters: { 
      getAnnouncements: (state) => (locale) => {
        return (state.announcement[locale] 
          && state.announcement[locale].messages) 
        || []
      },
      getInformations: (state) => (locale) => {
        return (state.announcement[locale] 
          && state.announcement[locale].information) 
        || []
      }
    }
  }
}